import { apiFetch } from "#lib/api";

interface IBody {
  username: string;
  password: string;
}

export async function changeUsername(
  username: string,
  password: string,
) {
  const body: IBody = {
    username,
    password,
  };

  const result = await apiFetch<true | { error: string }>("/account/change_username", { method: "POST", body });

  // TODO: Remove when duplicates are resolved.
  if (result === true) {
    localStorage.removeItem("is_duplicate");
  }

  return result;
}
